import { useStyles } from './style';
import { useHistory } from 'react-router-dom';

import CloseIcon from '@material-ui/icons/Close';

const SignUp: React.FC<{}> = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>Tilaa käyttäjätunnus</h2>
      <div className={classes.block}>
        <CloseIcon
          className={classes.closeIcon}
          onClick={() => history.push('/')}
        />
        <p className={classes.description}>
          Palvelu on käytössä Kiinteistötahkolan taloyhtiöasiakkaille. Saat
          tunnukset helposti ottamalla yhteyttä isännöinnin{' '}
          <a
            href="https://kiinteistotahkola.fi/yhteystiedot/#toimipisteet"
            target="_blank"
            rel="noopener noreferrer"
          >
            asiakaspalveluun
          </a>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
